import * as React from 'react';
import {thinMargins} from '../../constants';
import {Text} from '../../components/common';
import {useState} from 'react';

export const ContactFormNew = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => {
  const [showThanks, setShowThanks] = useState(false);

  return (
    <div className={`py-16 lg:py-24 text-black ${thinMargins}`}>
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
        {/* Left — heading + description + contacts */}
        <div className="lg:w-2/5 flex flex-col gap-5">
          <div className="flex flex-col gap-2">
            <Text as="h2" variant="Title">
              {title}
            </Text>
          </div>
          {subtitle && <p>{subtitle}</p>}
          <div className="flex flex-col bg-white gap-0 mt-4 rounded-2xl overflow-hidden">
            <div className="px-6 py-4 border-b border-black/10">
              <p className="text-smallbodymob text-black/60">
                Partnerships team
              </p>
              <a
                href="mailto:partnerships@weareluna.app"
                className="font-semibold text-smallbody hover:underline">
                partnerships@weareluna.app
              </a>
            </div>
            <div className="px-6 py-4">
              <p className="text-smallbodymob text-black/60">
                Press &amp; media
              </p>
              <a
                href="mailto:press@weareluna.app"
                className="font-semibold text-smallbody hover:underline">
                press@weareluna.app
              </a>
            </div>
          </div>
        </div>

        {/* Right — form card */}
        <div className="lg:w-3/5 bg-white rounded-2xl p-8 md:p-10 shadow-sm w-full">
          <iframe
            name="stopredirect"
            id="stopredirect"
            className="hidden"></iframe>
          <form
            action="https://europe-west2-luna-life-prod.cloudfunctions.net/getInTouch"
            method="GET"
            target="stopredirect"
            id="contactForm"
            onSubmit={() => {
              setShowThanks(true);
            }}>
            <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-5 w-full">
              <input
                type="text"
                id="key"
                name="key"
                defaultValue="t425638l"
                className="hidden"
              />
              <div className="flex flex-col gap-3">
                <label
                  htmlFor="firstName"
                  className="text-smallbodymob lg:text-smallbody font-poppins">
                  Name:
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  className="rounded-[1rem] h-[3.5rem] p-6 bg-background"
                  required={true}
                />
              </div>
              <div className="flex flex-col gap-3">
                <label
                  htmlFor="lastName"
                  className="text-smallbodymob lg:text-smallbody font-poppins">
                  Organisation:
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  className="rounded-[1rem] h-[3.5rem] p-6 bg-background"
                  required={true}
                />
              </div>
              <div className="flex flex-col gap-3 md:col-span-2 2xl:col-span-1">
                <label
                  htmlFor="email"
                  className="text-smallbodymob lg:text-smallbody font-poppins">
                  Work email:
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="rounded-[1rem] h-[3.5rem] p-6 bg-background"
                  required={true}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 pt-8">
              <label
                htmlFor="msg"
                className="text-smallbodymob lg:text-smallbody font-poppins">
                Tell us more:
              </label>
              <textarea
                id="msg"
                name="message"
                className="rounded-[1.5rem] min-h-[14.25rem] p-6 bg-background"
                placeholder="What would you know to know or explore, share any timelines or anything else we should know"
                required={true}
                minLength={5}></textarea>
            </div>
            <div
              id="thank_you"
              className={`font-poppins text-semibold ${
                showThanks ? 'block pt-6 text-center' : 'hidden'
              }`}>
              <p>thanks, we&apos;ll be in touch soon!</p>
            </div>
            <button
              type="submit"
              className={`${
                showThanks ? 'mt-4' : 'mt-10'
              } text-black font-semibold text-smallbody hover:text-hoverblack w-full py-3 px-6 rounded-3xl bg-sandwisp hover:bg-[#EBD384]`}
              id="submit">
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
